import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'

function getBase64FromImage(imgUrl) {
    return new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            resolve(canvas.toDataURL('image/png'))
        }
        img.src = imgUrl
    })
}

function formatearFecha(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
    return palabras.toUpperCase()
}

function formatearFechaHora(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(fecha))
}

// function campo(doc, label, value, x, y, width = 70) {
//   doc.setFontSize(8)
//   doc.setFont('helvetica', 'normal')
//   doc.text(label, x, y)
//   doc.setFontSize(9)

//   doc.setFont('helvetica', 'bold')
//   doc.text(value || '', x, y + 4)

//   doc.setDrawColor(0)
//   doc.line(x, y + 5, x + width, y + 5)
// }

function campo(doc, label, value, x, y, width = 70, minHeight = 10) {
    // Label
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0, 0, 0)
    doc.text(label, x, y)

    // Texto
    doc.setFontSize(8)
    doc.setTextColor(78, 78, 78)
    doc.setFont('helvetica', 'normal')

    const text = value || ''
    const textLines = doc.splitTextToSize(text, width - 4)
    const boxHeight = Math.max(minHeight, textLines.length * 3.4 + 2)

    // Caja gris SIN borde
    doc.setFillColor(245, 245, 245)
    doc.rect(x, y + 1, width, boxHeight, 'F')

    // Texto dentro
    doc.text(textLines, x + 2, y + 5)

    // 🔥 Borde inferior delgado
    doc.setDrawColor(208, 208, 208)      // gris elegante
    doc.setLineWidth(0.3)
    doc.line(x, y + 1 + boxHeight, x + width, y + 1 + boxHeight)

    return y + boxHeight + 6
}


function tituloSeccion(doc, texto, y) {
    doc.setFontSize(10)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0)
    doc.text(texto.toUpperCase(), 15, y)

    doc.setDrawColor(7, 88, 144)
    doc.setLineWidth(0.4)
    doc.line(15, y + 2, 200, y + 2)

    return y + 8
}

async function generarVisitaDomiciliaria(paciente, visita, firmas) {
    const doc = new jsPDF('p', 'mm', 'letter')
    const pageWidth = doc.internal.pageSize.getWidth()

    const logo1 = await getBase64FromImage(logoIzquierdo)
    const logo2 = await getBase64FromImage(logoDerecho)

    doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'bold')
    doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 25, { align: 'center' })
    doc.setFontSize(12)
    doc.text('REPORTE DE VISITA DOMICILIARIA', pageWidth / 2, 30, { align: 'center' })

    let y = 45
    y = tituloSeccion(doc, 'DATOS GENERALES', y)
    y = campo(doc, 'NOMBRE DEL PACIENTE:', visita.nombre, 15, y, 185, 5)

    campo(doc, 'EDAD:', visita.edad, 15, y, 55, 5)
    campo(doc, 'SEXO:', visita.sexo, 75, y, 65, 5)
    y = campo(doc, 'ESTADO CIVIL:', visita.estadoCivil, 145, y, 55, 5)
    y = campo(doc, 'GRADO DE ESTUDIOS:', visita.estudios, 15, y, 185, 5)

    y = campo(doc, 'DOMICILIO', visita.domicilio, 15, y, 185, 5)
    y = campo(doc, 'LOCALIDAD', visita.localidad, 15, y, 185, 5)
    y = campo(doc, 'MOTIVO DE LA VISITA', visita.motivoVisita, 15, y, 185, 5)
    y = campo(doc, 'PROGRAMA:', visita.programa, 15, y, 185, 5)
    y = campo(doc, 'RESULTADO:', visita.resultado, 15, y, 185, 5)
    y = campo(doc, 'OBSERVACIONES:', visita.observaciones, 15, y, 185, 5)

    doc.setTextColor(0)
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(10)

    let firmaPaciente = 'data:image/png;base64,' + firmas.base64P
    const lineaY = y

    const colW = 70                  
    const col1X = pageWidth / 4        
    const col2X = pageWidth / 4 * 3     

    doc.setFontSize(8)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(60, 60, 60)
    doc.text('NOMBRE Y FIRMA DEL ENTREVISTADO', col1X, lineaY, { align: 'center' })

    doc.addImage(firmaPaciente, 'PNG', col1X - 20, lineaY + 3, 40, 20)

    doc.setDrawColor(0, 0, 0)
    doc.line(col1X - colW / 2, lineaY + 26, col1X + colW / 2, lineaY + 26)

    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor(0, 0, 0)
    doc.text(formatMayusculas(visita.nombre), col1X, lineaY + 31, { align: 'center' })

    doc.setFontSize(8)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(60, 60, 60)
    doc.text('NOMBRE Y FIRMA DEL ENFERMERO', col2X, lineaY, { align: 'center' })

    doc.setDrawColor(0, 0, 0)
    doc.line(col2X - colW / 2, lineaY + 26, col2X + colW / 2, lineaY + 26)

    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor(0, 0, 0)
    // doc.text(formatMayusculas(firmas.nombreMedico), col2X, lineaY + 31, { align: 'center' })
    // doc.text(firmas.cedula, col2X, lineaY + 36, { align: 'center' })

    // doc.save('VisitaDomiciliaria.pdf')
    const base64 = doc.output('datauristring')
    return base64
}
export { generarVisitaDomiciliaria }